
import React from 'react';
import { useTranslation } from 'react-i18next';

interface InstructionsProps {
  instructions: string | null;
}

const Instructions: React.FC<InstructionsProps> = ({ instructions }) => {
  const { t } = useTranslation();
  
  if (!instructions) return null;
  
  // Convert the instructions string to an array of steps
  const steps = instructions.split('\n').filter(step => step.trim().length > 0);
  
  // Show only the first 3 steps and add a "Ver más" button if there are more
  const displaySteps = steps.slice(0, 3);
  const hasMoreSteps = steps.length > 3;
  
  return (
    <div className="mb-6">
      <h3 className="font-medium text-base mb-2">{t('instructions')}</h3>
      <ol className="list-decimal list-inside text-sm text-gray-700 space-y-1">
        {displaySteps.map((step, index) => (
          <li key={index} className="pl-1">{step}</li>
        ))}
      </ol>
      {hasMoreSteps && (
        <button className="text-xs text-sangre-500 mt-2 font-medium">
          {t('viewAllInstructions')}
        </button>
      )}
    </div>
  );
};

export default Instructions;
